import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Transactions from "../branding/transcation";
import BankDetails from "../branding/bank-details";
import CustomerBankDetails from "./CustomerBankDetails";
import BackIcon from "../../assets/images/back_icon.svg";
import TransactionsIcon from "../../assets/images/transactions_icon.svg";
import BanckAccIcon from "../../assets/images/banckAcc_icon.svg";
import BrandDetailsIcon from "../../assets/images/brandDetails_icon.svg";
import BanklistIcon from "../../assets/images/banklist_icon.svg";
import AddBankIcon from "../../assets/images/addBank_icon.svg";
import EditIcon from "../../assets/images/edit_icon.svg";
import creditcardIcon from "../../assets/images/creditCard_icon.svg";

import Editcashbackrule from "../branding/Editcashbackrule";
import ViewCustomerDetail from "./ViewCustomerDetails";
import VoucherIcon from "../../assets/images/voucher_icon.svg";
import CustomerWallet from "./CustomerWallet";
import CustomerVoucher from "./CustomerVoucher";
import CustomerTransactions from "./CustomerTransactions";
import ArrowleftIcon from "../../assets/images/arrowleft_icon.svg";
import { getUserWalletDetails } from "../../services/customer.service";
import { formatCurrency } from "../../utils/helpers/helper";
import toast from "react-hot-toast";
import CustomerCard from "./Customercard";
import { useTranslation } from 'react-i18next';  // Import useTranslation

const CustomerDetails = () => {
  const navigate = useNavigate();
  const { id, customer_name } = useParams();
  const { t, i18n } = useTranslation(); // Translation hook

  const tabs = {
    detail: "Customer Details",
    CustomerTransactions: "Transaction",
    CustomerBankDetails: "Bank Accounts",
    customerwallet: "Customer Wallet",
    CustomerVoucher: "Vouchers",
    CustomerCard: "Card",

  };
  // detail: t("customer.CustomerDetails"),
  // CustomerTransactions: t("transaction.Transactions"),
  // CustomerBankDetails: t("customer.BankAccounts"),
  // customerwallet: t("customer.CustomerWallet"),
  // CustomerVoucher: t("voucher.Vouchers"),
  // CustomerCard: t("customer.Cards"),
  const [activetab, setActiveTab] = useState(tabs.detail);
  const [addBank, setAddBank] = useState(false);
  const [walletData, setWalletData] = useState();
  const [wallettotalamount, setWallettoalamount] = useState({});
  console.log('wallettotalamount::: ', wallettotalamount);

  console.log("walletData::: ", walletData);

  let [totalCount, setTotalCount] = useState(0);
  let [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState(10);
  let [searchKey, setSearchKey] = useState("");
  let [isLoading, setIsLoading] = useState(true);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);
  const [range, setRange] = useState({
    startDate: undefined,
    endDate: new Date(),
  });


  const getWalletData = async (id) => {
    const offset = (currentPage - 1) * itemsPerPage;
      const offsetToUse = offset >= 0 ? offset : 0;
    console.log('id::: ', id);
    try {
      const requestBody = {
        offset: offsetToUse,
        limit: itemsPerPage,
        // search: searchKey,
        // startDate: convertToISOString(range.startDate),
        // endDate: convertToISOString(range.endDate),
      };
      const res = await getUserWalletDetails(id,requestBody);
      console.log('res::: 99999999999999999999', res);
      if (res?.status === 200 && res?.data?.statusCode === 200) {
  
        // setWalletData(res?.data?.data);
        setWallettoalamount(res?.data?.data?.wallet_amount)
      } else {
        toast.error(res?.message || res?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching wallet data:", error.message);
      
      // toast.error("Failed to fetch wallet data");
    }
  };

  const walletAmount = walletData ? walletData.wallet_amount : null;
  console.log('walletAmount::: ', walletAmount);

  useEffect(() => {
    getWalletData(id);
    console.log(customer_name);
  }, [customer_name, id]);

  const handleClick = () => {
    navigate(-1);
  };

  return (
    <div>
      <h2 className="fontSize20 blackClr_text mb_16">
        <span className="fontWeight400">{t("customer.CustomerName")} - </span>
        <span className="fontWeight500">{customer_name}</span>
      </h2>
      <ul className="horizontalTablist">
        <li>
          <button
            onClick={() => setActiveTab(tabs.detail)}
            className={activetab === tabs.detail ? "active" : ""}
          >
            <img src={BrandDetailsIcon} alt="BrandDetailsIcon" />
            {t("customer.CustomerDetails")}
          </button>
        </li>
        <li>
          <button
            onClick={() => setActiveTab(tabs.CustomerBankDetails)}
            className={activetab === tabs.CustomerBankDetails ? "active" : ""}
          >
            <img src={BanckAccIcon} alt="BanckAccIcon" />
            <span>{t("customer.BankAccounts")}</span>
          </button>
        </li>
        <li>
          <button
            onClick={() => setActiveTab(tabs.CustomerTransactions)}
            className={activetab === tabs.CustomerTransactions ? "active" : ""}
          >
            <img src={TransactionsIcon} alt="TransactionsIcon" />
            <span>{t("transaction.Transactions")}</span>
          </button>
        </li>
        <li>
          <button
            onClick={() => setActiveTab(tabs.customerwallet)}
            className={activetab === tabs.customerwallet ? "active" : ""}
          >
            <img src={BrandDetailsIcon} alt="Customer Wallet" />
            <span>{t("customer.CustomerWallet")}</span>
          </button>
        </li>
        <li>
          <button
            onClick={() => setActiveTab(tabs.CustomerVoucher)}
            className={activetab === tabs.CustomerVoucher ? "active" : ""}
          >
            <img src={VoucherIcon} alt="VoucherIcon" />
            <span>{t("voucher.Vouchers")}</span>
          </button>
        </li>
        <li>
          <button
            onClick={() => setActiveTab(tabs.CustomerCard)}
            className={activetab === tabs.CustomerCard ? "active" : ""}
          >
            <img src={creditcardIcon} alt="creditcardIcon" />
            <span>{t("customer.Cards")}</span>
          </button>
        </li>
      </ul>
      <br />

      <div className="whiteFrame">
        <div className="mb_24 displayFlex alignItem_center justifyContent_spacebetween BorderBottom_LavenderSyrup pb_16">
          <div className="displayFlex alignItem_center gap12">
            <div>
              <button className="emptyBtn" onClick={handleClick}>
                <img src={ArrowleftIcon} alt="ArrowleftIcon" />
              </button>
            </div>
            <div>
              <h5 className="fontSize20 fontWeight600 blackClr_text">
                {activetab}
              </h5>
            </div>
          </div>
          <div className="displayFlex alignItem_center gap12">
            {activetab === tabs.customerwallet && (
              <div className={`walletAmountFrame ${"active"}`}>
                {t("customer.WalletAmount")}: {formatCurrency(wallettotalamount)}
              </div>
            )}

            {/* {tabs.CustomerBankDetails === activetab && (
              <div>
                <button
                  className="MainButton lemonPie_clr gap8"
                  onClick={() => setAddBank(!addBank)}
                >
                  {addBank ? (
                    <img src={BanklistIcon} alt="BanklistIcon" />
                  ) : (
                    <img src={AddBankIcon} alt="AddBankIcon" />
                  )}
                  {addBank ? "Bank List" : "Add bank details"}
                </button>
              </div>
            )} */}

            {/* <div>
                {activetab === tabs.detail  &&(
                <button
                  className="MainButton cyanSky_clr gap8"
                  type="button"
                  onClick={() => setActiveTab(tabs.edit)}
                >
                  <img className='width20px' src={EditIcon} alt='EditIcon' />
                  <span> Edit </span>
                </button>
                )}
              </div> */}
            <div>
              {activetab === tabs.Edit_cash_rule && (
                <button
                  className="MainButton cyanSky_clr gap8"
                  type="button"
                  onClick={() => setActiveTab(tabs.Edit_cash_rule)}
                >
                  <img className="width20px" src={EditIcon} alt="EditIcon" />
                  <span> {t("common.Edit")} </span>
                </button>
              )}
            </div>
            {/* <div>
              <button
                className="MainButton cyanSky_clr gap8"
                type="button"
                onClick={handleClick}
              >
                <img src={BackIcon} alt="BackIcon" />
                <span> Back </span>
              </button>
            </div> */}
          </div>
        </div>
        {activetab === tabs.detail && <ViewCustomerDetail />}
        {activetab === tabs.CustomerTransactions && <CustomerTransactions />}
        {activetab === tabs.customerwallet && <CustomerWallet />}
        {activetab === tabs.CustomerCard && <CustomerCard />}

        {activetab === tabs.CustomerVoucher && <CustomerVoucher />}
        {activetab === tabs.CustomerBankDetails && (
          <CustomerBankDetails addBank={addBank} setAddBank={setAddBank} />
        )}
        {activetab === tabs.edit && (
          <Editcashbackrule back={() => setActiveTab(tabs.Edit_cash_rule)} />
        )}
      </div>
    </div>
  );
};

export default CustomerDetails;
